<div *ngIf="(OrganizationData != null && OrganizationData.length > 2) || (yearData != null && yearData.length > 2) || (monthData != null && monthData.length > 2 && organizationMonth)" [@loadedHeightAnimation]="'visible'" class="filters mb-3">
  <!-- <div><strong>Filtros</strong></div> -->
  <div class="row">
    <div *ngIf="OrganizationData != null && OrganizationData.length > 2" class="col-md-3">
      <select2 [data]="OrganizationData" (update)="onChangeOrganization($event)" [placeholder]="'Seleccionar categoría'" [(ngModel)]="idOrganizationFilter"></select2>
    </div>
    <div *ngIf="yearData != null && yearData.length > 2" class="col-md-3">
      <select2 [data]="yearData" (update)="onChangeYear($event)" [placeholder]="'Ano'" [(ngModel)]="idYearFilter"></select2>
    </div>
    <div *ngIf="monthData != null && monthData.length > 2 && organizationMonth" class="col-md-3">
      <select2 [data]="monthData" [placeholder]="'Mês'" [(ngModel)]="idMonthFilter"></select2>
    </div>
    <div class="col-auto">
      <button class="btn-search" type="button" (click)="rerender()"><fa-icon [icon]="['fas','search']" class="fa-lg"></fa-icon><span class="visually-hidden">Pesquisar</span></button>
    </div>
  </div>
</div>

<div class="document-card-row" *ngIf="data != null && data.length > 0" [@loadedHeightAnimation]="'visible'">
  <ng-container *ngFor="let item of data">
    <div class="col">
      <div class="card">
        <img *ngIf="item && item.ImageFile" [src]="item.ImageFile.FileUri" class="card-img-top" alt="{{item.Title}}" onerror="this.src='assets/images/noImage.png'">
        <div class="card-body">
          <div class="card-title">
            {{item.Title}}
          </div>
          <div class="card-text external-html" [innerHTML]="item.Description"></div>
        </div>
        <div class="card-footer">
          <div class="btn-group" role="group">
            <!-- estilo renault -->
            <a *ngIf="item.File" (click)="trackDocument(item.IdDocument) " [href]="item.File.FileUri" class="btn-orange-border btn-icon">
              <div class="svg-icon">
                <svg viewBox="0 0 150 150">
                  <use xlink:href='assets/images/icons/ico_download_auto.svg#img' href="assets/images/icons/ico_download_auto.svg#img"></use>
                </svg>
              </div>
              Download
            </a>
            <!-- estilo stihl -->
            <!-- <a *ngIf="item.File" (click)="downloadDocument(item.IdDocument,item.File.FileName) " [href]="item.File.FileUri" class="btn-orange-border btn-icon">
              <div class="svg-icon">
                <svg viewBox="0 0 150 150">
                  <use xlink:href='assets/images/icons/ico_download_auto.svg#img' href="assets/images/icons/ico_download_auto.svg#img"></use>
                </svg>
              </div>
              Download
            </a> -->

            <a *ngIf="item.URL" [href]="item.URL" class="btn-orange-border btn-icon" target="_blank ">
              <div class="svg-icon">
                <svg viewBox="0 0 150 150">
                  <use xlink:href='assets/images/icons/ico_link_auto.svg#img' href="assets/images/icons/ico_link_auto.svg#img"></use>
                </svg>
              </div>
              Aceder
            </a>
          </div>
        </div>
        <div class="ico-new" *ngIf="item.New"><img src="assets/images/icons/ico_New2.svg " title="Novo" /></div>
      </div>
    </div>
  </ng-container>
</div>

<div *ngIf="showProgress">
  <app-progress-bar [progress]="progress"></app-progress-bar>
</div>